const i18n = {
  window1: {
    title: "Window 1",
    content: "Draggable, resizable, minimizable and maximizable. Bounded to the top-left of screen.",
  },
  window2: {
    title: "Window 2",
    content: "Only draggable. Has no bounds.",
  },
  window3: {
    title: "Window 3",
    content: "Starting minimized. Bounded to the right side of screen",
  },
};

export default i18n;
